var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompleteLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 75,
    r: 74,
    stroke: "url(#paint0_linear_9_864)",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9_864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75 42.5C80.0412 42.5 84.8118 43.6485 89.0745 45.697C87.3297 47.0774 85.7119 48.4026 84.2045 49.678C81.3332 48.6345 78.2356 48.0657 75.0055 48.0657C67.568 48.0657 60.8316 51.0805 55.9616 55.9561C51.0861 60.8316 48.0713 67.5624 48.0713 75C48.0713 82.4376 51.0861 89.1684 55.9616 94.0439C60.8372 98.9195 67.568 101.934 75.0055 101.934C82.4431 101.934 89.1794 98.9195 94.0494 94.0439C98.925 89.1684 101.94 82.4376 101.94 75C101.94 73.2331 101.769 71.4993 101.443 69.8263C102.84 68.0042 104.27 66.1876 105.733 64.3875C106.882 67.7115 107.506 71.284 107.506 75C107.506 83.9726 103.867 92.1003 97.9863 97.9808C92.1058 103.861 83.9781 107.5 75.0055 107.5C66.033 107.5 57.9052 103.861 52.0247 97.9808C46.1387 92.1003 42.5 83.9726 42.5 75C42.5 66.0274 46.1387 57.8997 52.0192 52.0192C57.8997 46.1387 66.0274 42.5 75 42.5ZM59.8598 69.6606L67.7888 69.5557L68.3796 69.7103C69.9809 70.6324 71.4883 71.6871 72.8963 72.8797C73.9122 73.7411 74.884 74.6797 75.8061 75.6957C78.6498 71.1183 81.6811 66.9164 84.8836 63.0513C88.3898 58.8163 92.1114 54.9732 96.0206 51.467L96.7937 51.1689H105.446L103.701 53.1069C98.3397 59.0647 93.4752 65.2213 89.08 71.5711C84.6848 77.9264 80.7535 84.4861 77.2583 91.239L76.1706 93.3372L75.1712 91.2003C73.327 87.2413 71.1183 83.6081 68.4845 80.3615C65.8507 77.1148 62.7863 74.2325 59.2138 71.7809L59.8598 69.6606Z",
    fill: "url(#paint1_linear_9_864)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9_864",
    x1: 75,
    y1: 0.00000109061,
    x2: 110.481,
    y2: 191.914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A175FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#563AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9_864",
    x1: 75.0028,
    y1: 42.5,
    x2: 90.3767,
    y2: 125.663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A175FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#563AFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9_864"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 65,
    fill: "white",
    transform: "translate(42.5 42.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleteLogo);
export default __webpack_public_path__ + "static/media/CompleteLogo.08bdb473cf4199069dbfa25b096dcbb7.svg";
export { ForwardRef as ReactComponent };